/*
 * The chief editor views english translation
 */
export const CHIEF_EDITOR_EN = {
  // chief-editor-Data-table-dropdown.vue
  openMenu: 'Open menu',
  actions: 'Actions',
  openArticle: 'Open Article',
  copyOutputText: 'Copy output text',
  openInEditor: 'Open in Editor',
  tryAdjustingYourSearchQuery: 'Try adjusting your search Query',
  deleteArticle: 'Delete Article',
  // ChiefEditorRewardColumns.ts - doesnt work in file
  manageAndReviewAllGeneratedContentAcrossOrganisation:
    'Manage and review all generated content across your organization',
  noContentFound: 'No Content found',
  currentOrganisation: 'Current Organisation',
  userChiefEditor: 'User Chief Editor',
  manageAndReviewUserGeneratedContent: 'Manage and review generated content for this user'
}
/*
 * The chief editor views german translation
 */
export const CHIEF_EDITOR_DE = {
  // chief-editor-Data-table-dropdown.vue
  openMenu: 'Menü offnen',
  actions: 'Aktionen',
  openArticle: 'Artikel öffnen',
  copyOutputText: 'Output-Text kopieren',
  openInEditor: 'im Editor öffnen',
  tryAdjustingYourSearchQuery: 'Suchanfrage anpassen',
  deleteArticle: 'Artikel löschen',
  // ChiefEditorRewardColumns.ts - doesnt work in file
  manageAndReviewAllGeneratedContentAcrossOrganisation:
    'Verwalten Sie allen generierten Content Ihrer Organisation',
  noContentFound: 'Kein Content gefunden',
  currentOrganisation: 'Aktuelle Organisation',
  userChiefEditor: 'Benutzer Chefredakteur',
  manageAndReviewUserGeneratedContent:
    'Verwalten und überprüfen Sie generierten Inhalt für diesen Benutzer'
}
